// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"HelpResponse_contentSection__NK_iG","contentCardSection":"HelpResponse_contentCardSection__4md7a","faqSection":"HelpResponse_faqSection__nTnQr"};